import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DEFAULT_KEY_SIGNATURE_DISPLAY,
  type KeySignatureDisplay,
} from 'Seeds/ExerciseContent/scaleNotation';
import { normalizeKeySignatureDisplay } from './keySignatureDisplaySettings';

export interface KeySignatureDisplayState {
  display: KeySignatureDisplay;
}

const initialState: KeySignatureDisplayState = { display: DEFAULT_KEY_SIGNATURE_DISPLAY };

/**
 * The key-signature display setting in Redux. Not redux-persisted: it follows the
 * signed-in user when one account signs out and another signs in without a
 * reload, so `useKeySignatureDisplaySync` loads it from the user's namespaced
 * storage and saves it back.
 */
const keySignatureDisplaySlice = createSlice({
  name: 'keySignatureDisplay',
  initialState,
  reducers: {
    setKeySignatureDisplay(
      _state,
      action: PayloadAction<KeySignatureDisplay>,
    ): KeySignatureDisplayState {
      return { display: normalizeKeySignatureDisplay(action.payload) };
    },
    keySignatureDisplayHydrated(
      _state,
      action: PayloadAction<KeySignatureDisplay>,
    ): KeySignatureDisplayState {
      return { display: normalizeKeySignatureDisplay(action.payload) };
    },
  },
});

export const { setKeySignatureDisplay, keySignatureDisplayHydrated } =
  keySignatureDisplaySlice.actions;

export const keySignatureDisplayReducer = keySignatureDisplaySlice.reducer;

// Falls back to the default for a store built without this slice (test stores).
export const selectKeySignatureDisplay = (state: {
  keySignatureDisplayReducer?: KeySignatureDisplayState;
}): KeySignatureDisplay =>
  state.keySignatureDisplayReducer?.display ?? DEFAULT_KEY_SIGNATURE_DISPLAY;
